import React from "react";

import FilterChip from "../../../../components/filter-chip/FilterChip";
import type { TaskCompletionFilter } from "./taskBoardUtils";

/** チップの並びとラベル（他のフィルター行と同じく「すべて」を先頭に置く） */
const OPTIONS: { value: TaskCompletionFilter; label: string }[] = [
  { value: "all", label: "すべて" },
  { value: "incomplete", label: "未完了" },
  { value: "complete", label: "完了" },
];

interface CompletionFilterChipsProps {
  value: TaskCompletionFilter;
  // eslint-disable-next-line no-unused-vars
  onChange: (next: TaskCompletionFilter) => void;
}

/**
 * タスク表の完了フィルター（未完了 / 完了 / すべて）。
 * 担当者フィルターと同じ `FilterChip` で揃える。
 */
const CompletionFilterChips: React.FC<CompletionFilterChipsProps> = ({
  value,
  onChange,
}) => (
  <div className="u-row u-items-center u-gap8">
    {OPTIONS.map((option) => (
      <FilterChip
        key={option.value}
        selected={value === option.value}
        onClick={() => onChange(option.value)}
        className="u-flex-shrink-0"
      >
        {option.label}
      </FilterChip>
    ))}
  </div>
);

export default CompletionFilterChips;
